import { render, staticRenderFns } from "./SwitchMock.vue?vue&type=template&id=3af2c858&"
import script from "./SwitchMock.vue?vue&type=script&lang=ts&"
export * from "./SwitchMock.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchMock.vue?vue&type=style&index=0&id=3af2c858&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports